import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {UserEmailsSearchComponent} from '../../shared';
import {EscalationMailComponent} from '../e-mails/escalation-mail.component';
import {EQueryAccessionInfo} from '../../shared/e-query-accession-info';

export class EscalationMailFormControl extends FormControl {
    public value: string[];
}

@Component({
    selector: 'escalations',
    template: require('./escalations.component.html'),
    styles: [require('./escalations.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EscalationsComponent {
    @Input()
    public readonly escalationsErrorMessage: string;
    @Input()
    public readonly escalationMailsSiteCtrl: EscalationMailFormControl;
    @Input()
    public readonly escalationMails2Ctrl: EscalationMailFormControl;
    @Input()
    public readonly escalationMails1Ctrl: EscalationMailFormControl;
    @Input()
    public readonly accessionSubject: EQueryAccessionInfo;
    public firstEmailEntered: boolean;
    public secondEmailEntered: boolean;
    public hideErrorMessage: boolean;
    public customErrorMessage: string;

    @ViewChild('secondEmail')
    private secondEmailComponent: EscalationMailComponent;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    public submitEmail1(isValid: boolean) {
        this.firstEmailEntered = isValid;
    }

    public submitEmail2(isValid: boolean) {
        this.secondEmailEntered = isValid;
    }

    public checkThirdEmail(mailCtrl: EscalationMailFormControl, isValid: boolean, childMailCtrl: EscalationMailFormControl = null) {
        this.validateEmail(mailCtrl, isValid, childMailCtrl);
        this.validateEmail(this.escalationMails1Ctrl, this.secondEmailComponent.formMails.valid, this.escalationMails2Ctrl);
    }

    public checkSecondEmail(mailCtrl: EscalationMailFormControl, isValid: boolean, childMailCtrl: EscalationMailFormControl = null) {
        this.validateEmail(mailCtrl, isValid, childMailCtrl);
    }

    public setEmailErrors(mailCtrl: EscalationMailFormControl, isValid: boolean) {
        mailCtrl.setErrors(!isValid ? { 'incorrect': !isValid } : null);
        this.changeDetectorRef.detectChanges();
    }

    private validateEmail(mailCtrl: EscalationMailFormControl,
                          isValid: boolean,
                          childMailCtrl: EscalationMailFormControl = null) {
        if (mailCtrl.value.length === 1
            && mailCtrl.value[0] === '') {
            mailCtrl.setErrors(null);
        } else {
            if (childMailCtrl
                && childMailCtrl.value.length > 0
                && mailCtrl.value.length === 0) {
                isValid = false;
                this.customErrorMessage = 'You cannot set value for the third level while current is empty';
            } else {
                if (childMailCtrl) {
                    this.setEmailErrors(childMailCtrl, true);
                }
                this.customErrorMessage = '';
            }
            this.setEmailErrors(mailCtrl, isValid);
        }
    }
}
